<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>薪酬统计</span>
    </div>
    <!-- 菜单条件筛选部分 -->
    <div class="menu-select">
      <div @click="companySelectShow=true">
        <span>{{companySelectConfirmText}}</span>
        <a-icon type="down" style="" />
      </div>
      <div @click="dateSelectShow=true">
        <span>{{timeSelectConfirmText}}</span>
        <a-icon type="down" />
      </div>
    </div>
    <!-- echarts图表部分 -->
    <div class="echart-show">
      <div>
        <div>应发薪资构成分析<span>（单位：万元）</span></div>
        <div id="one-echart" v-show="shouldSalaryList.length>0"></div>
        <div class="no-data" v-show="shouldSalaryList.length==0">
          <img src="../assets/propertyImg/no-data.png" alt="" />
          <span>暂无图表数据</span>
        </div>
      </div>
      <div>
        <div>岗位占比分析<span>（单位：万元）</span></div>
        <div id="two-echart" v-show="positionSalaryList.length>0"></div>
        <div class="no-data" v-show="positionSalaryList.length==0">
          <img src="../assets/propertyImg/no-data.png" alt="" />
          <span>暂无图表数据</span>
        </div>
      </div>
      <div>
        <div>应发薪资*社保缴纳*公积金缴纳趋势图<span>（单位：万元）</span></div>
        <div id="three-echart" v-show="siList.length>0"></div>
        <div class="no-data" v-show="siList.length==0">
          <img src="../assets/propertyImg/no-data.png" alt="" />
          <span>暂无图表数据</span>
        </div>
      </div>
      <div>
        <div>薪资构成占比分析<span>（单位：万元）</span></div>
        <div id="four-echart" v-show="salaryStructureList.length>0"></div>
        <div class="no-data" v-show="salaryStructureList.length==0">
          <img src="../assets/propertyImg/no-data.png" alt="" />
          <span>暂无图表数据</span>
        </div>
      </div>
    </div>
    <!-- 公司选择 -->
    <van-popup v-model="companySelectShow" position="bottom">
      <div>
        <div class="pop-title">
          <span>请选择</span>
          <span @click="confirmSelect">确定</span>
        </div>
        <div class="tab-content">
          <van-tabs v-model="active">
            <van-tab title="请选择公司">
              <div class="list-content">
                <div :style="{ color: companySelect=='all'?'#3293FD':'#323233'}" @click="selectAllCompany">全部</div>
                <div v-for="(item,index) in companyList" :key="index" @click="selectCompany(item,index)" :style="{ color: companySelect==index?'#3293FD':'#323233'}">{{item.name}}</div>
              </div>
            </van-tab>
            <van-tab title="请选择部门">
              <div class="list-content">
                <div :style="{ color: officeSelect=='all'?'#3293FD':'#323233'}" @click="selectAllOffice">全部</div>
                <div v-for="(item,index) in officeList" :key="index" @click="selectOffice(item,index)" :style="{ color: officeSelect==index?'#3293FD':'#323233'}">{{item.name}}</div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </van-popup>
    <!-- 时间日期选择 -->
    <van-popup v-model="dateSelectShow" position="bottom">
      <div>
        <div class="date-title">
          <span @click="dateSelectShow=false">取消</span>
          <span>请选择</span>
          <span @click="dateConfirm">确定</span>
        </div>
        <div class="type-select">
          <span :style="{ background: currentSelect==0?'#1484FF':'#FFFFFF',color: currentSelect==0?'#FFFFFF':'#1484FF'}" @click="currentSelect=0">按月</span>
          <span :style="{ background: currentSelect==1?'#1484FF':'#FFFFFF',color: currentSelect==1?'#FFFFFF':'#1484FF'}" @click="currentSelect=1">范围</span>
        </div>
        <div class="date-selector">
          <div class="one-div" v-if="currentSelect==0">
            <van-datetime-picker
              v-model="singleDate"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
            />
          </div>
          <div class="two-div" v-else>
            <van-datetime-picker
              v-model="comboOneDate"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
            />
            <span>至</span>
            <van-datetime-picker
              v-model="comboTwoDate"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { salaryCount,getAddressBook } from "../axios/remunerationManagement";
export default {
  components: {},
  data() {
    return {
      companyId: "",
      companySelectShow: false,
      companySelectText: '全部公司',
      timeSelectText: '请选择时间',
      companySelectConfirmText: '全部公司',
      timeSelectConfirmText: '请选择时间',
      singleDate: new Date(),
      comboOneDate: new Date(),
      comboTwoDate: new Date(),
      companySelect: 'all',
      officeSelect: 'all',
      dateSelectShow: false,
      currentSelect: 0,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      active: 0,
      dailyFormInline: {
        type: "",
        selectCompanyId: "",
        selectOfficeId: "",
        startDate: "",
        endDate: "",
      },
      allData: {}, // 总数据
      shouldSalaryList: [], // 应发工资
      positionSalaryList: [], // 岗位占比
      salaryStructureList: [], // 薪资构成占比
      salaryList: [], // 应发薪资占比
      siList: [], // 社保缴纳占比
      fundList: [], // 公积金占比
      dateList: [], // 日期
      companyList: [],
      officeList: []
    };
  },
  created() {
    console.log(this.$store.state.initialData);
    this.companyId = this.$store.state.initialData.companyId;
    this.getAllData();
    this.getMineInfo();
  },
  activated() {
    console.log(666);
    this.companyId = this.$store.state.initialData.companyId;
    this.getAllData();
    this.getMineInfo();
  },
  methods: {
    dateConfirm(){ // 日期选择框确认
      console.log(this.singleDate.getMonth()+1)
      if(this.currentSelect==0){
        let year = this.singleDate.getFullYear()
        let month = this.singleDate.getMonth()+1
        if(month<10){
          month = '0' + month
        }
        this.dailyFormInline.startDate = year + '-' + month
        this.dailyFormInline.endDate = year + '-' + month
      } else {
        let startYear = this.comboOneDate.getFullYear()
        let startMonth = this.comboOneDate.getMonth()+1
        let endYear = this.comboTwoDate.getFullYear()
        let endMonth = this.comboTwoDate.getMonth()+1
        if(startMonth<10){
          startMonth = '0' + startMonth
        }
        if(endMonth<10){
          endMonth = '0' + endMonth
        }
        this.dailyFormInline.startDate = startYear + '-' + startMonth
        this.dailyFormInline.endDate = endYear + '-' + endMonth
      }
      this.timeSelectText = this.dailyFormInline.startDate + ' ~ ' + this.dailyFormInline.endDate
      this.dateSelectShow = false
      this.getAllData()
    },
    formatter(type, val) { // 日期格式
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    confirmSelect(){ // 确认公司/部门选择
      this.companySelectShow = false
      this.companySelectConfirmText = this.companySelectText
      this.timeSelectConfirmText = this.timeSelectText
      this.getAllData()
    },
    selectOffice(obj,index){ // 选择部门
      console.log(obj)
      this.officeSelect = index
      this.dailyFormInline.selectOfficeId=obj.officeId
      this.dailyFormInline.type=1
      this.companySelectText = obj.officeName
    },
    selectAllOffice(){ // 选择部门
      this.officeSelect = 'all'
      this.dailyFormInline.selectOfficeId=""
      this.dailyFormInline.type=0
      this.companySelectText = '全部部门'
    },
    selectCompany(obj,index){ // 选择公司
      console.log(obj)
      this.companySelect = index
      this.officeList = obj.childList
      this.dailyFormInline.selectCompanyId=obj.companyId
      this.dailyFormInline.type=0
      this.companySelectText = obj.companyName
    },
    selectAllCompany(){
      this.companySelect = 'all'
      this.dailyFormInline.selectCompanyId=""
      this.dailyFormInline.type=""
      this.officeList = []
      this.companySelectText = '全部'
    },
    getMineInfo(){ // 获取公司信息服务
      let that = this
      let requestData = {
        companyId: this.companyId,
        allShowView: 1
      }
      getAddressBook(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
          that.companyList = res.data.data
        }
      })
    },
    getAllData() {
      let that = this;
      for (let i in this.dailyFormInline) {
        if (this.dailyFormInline[i] === "") {
          delete this.dailyFormInline[i];
        }
      }
      let requestData = {
        companyId: this.companyId,
        ...this.dailyFormInline,
      };
      salaryCount(requestData).then((res) => {
        if (res.data.code == 0) {
          that.allData = res.data.data;
          let arr = [];
          that.allData.shouldSalaryStatisticsVos = that.allData.shouldSalaryStatisticsVos.sort(function(a,b){return b.totalShouldSalary-a.totalShouldSalary})
          for (
            let i = 0;
            i < that.allData.shouldSalaryStatisticsVos.length;
            i++
          ) {
            if(i<=4){
              if (
                that.allData.shouldSalaryStatisticsVos[i].totalShouldSalary > 0
              ) {
                arr.push({
                  ...that.allData.shouldSalaryStatisticsVos[i],
                  value: (
                    that.allData.shouldSalaryStatisticsVos[i].totalShouldSalary /
                    10000
                  ).toFixed(2),
                });
              }
            }
          }
          let positionArr = [];
          that.allData.postStatisticsVos = that.allData.postStatisticsVos.sort(function(a,b){return b.postShouldSalary-a.postShouldSalary})
          for (let i = 0; i < that.allData.postStatisticsVos.length; i++) {
            if(i<=4){
              if (that.allData.postStatisticsVos[i].postShouldSalary > 0) {
                positionArr.push({
                  ...that.allData.postStatisticsVos[i],
                  value: (
                    that.allData.postStatisticsVos[i].postShouldSalary / 10000
                  ).toFixed(2),
                  name: that.allData.postStatisticsVos[i].postName,
                });
              }
            }
            
          }
          let structureArr = [];
          that.allData.salaryStructureStatisticsVos = that.allData.salaryStructureStatisticsVos.sort(function(a,b){return b.value-a.value})
          for (
            let i = 0;
            i < that.allData.salaryStructureStatisticsVos.length;
            i++
          ) {
            if(i<=4){
              if (that.allData.salaryStructureStatisticsVos[i].value > 0) {
                structureArr.push({
                  ...that.allData.salaryStructureStatisticsVos[i],
                  name: that.allData.salaryStructureStatisticsVos[i].fieldName,
                  value: (
                    that.allData.salaryStructureStatisticsVos[i].value / 10000
                  ).toFixed(2),
                });
              }
            }
          }
          let salaryArr = [];
          for (
            let i = 0;
            i < that.allData.salaryEveryMonthStatisticsVos.length;
            i++
          ) {
            salaryArr.push(
              (
                that.allData.salaryEveryMonthStatisticsVos[i].shouldSalary /
                10000
              ).toFixed(2)
            );
          }
          let siArr = [];
          for (
            let i = 0;
            i < that.allData.salaryEveryMonthStatisticsVos.length;
            i++
          ) {
            siArr.push(
              (
                that.allData.salaryEveryMonthStatisticsVos[i].firmSi / 10000
              ).toFixed(2)
            );
          }
          let fundArr = [];
          for (
            let i = 0;
            i < that.allData.salaryEveryMonthStatisticsVos.length;
            i++
          ) {
            fundArr.push(
              (
                that.allData.salaryEveryMonthStatisticsVos[i].firmFund / 10000
              ).toFixed(2)
            );
          }
          let dateArr = [];
          for (
            let i = 0;
            i < that.allData.salaryEveryMonthStatisticsVos.length;
            i++
          ) {
            dateArr.push(that.allData.salaryEveryMonthStatisticsVos[i].date);
          }
          that.shouldSalaryList = arr;
          that.positionSalaryList = positionArr;
          that.salaryStructureList = structureArr;
          that.salaryList = salaryArr;
          that.siList = siArr;
          that.fundList = fundArr;
          that.dateList = dateArr;
          that.$nextTick(()=>{
            that.myOneEcharts();
            that.myTwoEcharts();
            that.myThreeEcharts();
            that.myFourEcharts();
          })
        }
      });
    },
    myOneEcharts() {
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("one-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        title: [
          {
            text: (this.allData.totalShouldSalary / 10000).toFixed(2),
            // left: this.allData.totalShouldSalary>0?"40%":"18%",
            left: "center",
            top: "28%",
            textStyle: {
              fontSize: 18,
              color: "#333333",
              align: "center",
            },
          },
          {
            text: "应发薪资总金额",
            // left: "38.5%",
            left: "center",
            top: "35%",
            textStyle: {
              fontSize: 10,
              color: "#999999",
              align: "right",
            },
          },
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "30%",
          textStyle: {
            rich: {
              name: {
                fontSize: 12,
                color: "#666666",
                padding: [0, 20, 0, 0],
              },
              num: {
                fontSize: 18,
                fontWeight: 600,
                padding: [0, 0, 0, 0],
                color: "#333333",
              },
              limit: {
                fontSize: 12,
                width: 50,
                padding: [0, 0, 0, 0],
                color: "#666666",
              }
            },
          },
          formatter: function(name) {
            let tarValue;
            if (that.shouldSalaryList.length > 0) {
              let realName = ""
              for (let i = 0; i < that.shouldSalaryList.length; i++) {
                if (that.shouldSalaryList[i].name == name) {
                  tarValue = that.shouldSalaryList[i].value;
                }
                if(name.length>7){
                  realName = name.slice(0,8) + '...'
                } else {
                  realName = name
                }
              }
              return [`{name|${realName}} {num|${tarValue}}{limit|万元}`];
            }
          },
          icon: "circle",
          bottom: "5%",
          left: "23%",
        },
        series: [
          {
            name: "应发薪资",
            type: "pie",
            radius: ["35%", "55%"],
            center: ["50%", "34%"],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
            },
            labelLine: {
              show: false,
            },
            data: this.shouldSalaryList,
          },
        ],
      };
      myChart.setOption(option);
    },
    myTwoEcharts() {
      // var myChart = this.$echarts.init(document.getElementById("two-echart"),'light');
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("two-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "30%",
          textStyle: {
            rich: {
              name: {
                fontSize: 12,
                color: "#666666",
                width: 95,
                padding: [0, 0, 0, 0],
              },
              num: {
                fontSize: 18,
                fontWeight: 600,
                padding: [0, 0, 0, 0],
                color: "#333333",
              },
              limit: {
                fontSize: 12,
                width: 50,
                padding: [0, 0, 0, 0],
                color: "#666666",
              },
              per: {
                fontSize: 18,
                fontWeight: 600,
                padding: [0, 0, 0, 0],
                color: "#333333",
              },
            },
          },
          formatter: function(name) {
            let tarValue;
            let total = 0;
            if (that.positionSalaryList.length > 0) {
              for (let i = 0; i < that.positionSalaryList.length; i++) {
                total += parseFloat(that.positionSalaryList[i].value);
                if (that.positionSalaryList[i].name == name) {
                  tarValue = parseFloat(that.positionSalaryList[i].value);
                }
              }
              console.log(tarValue,total)
              console.log(tarValue / total)
              let percent = ((tarValue / total) * 100).toFixed(2);
              return [`{name|${name}} {num|${tarValue}}{limit|万元}{per|占比${percent}%}`];
            }
          },
          icon: "circle",
          bottom: "2%",
          right: "0%",
        },
        series: [
          {
            name: "岗位占比",
            type: "pie",
            radius: ["0%", "55%"],
            center: ["50%", "33%"],
            label: {
              show: false,
              position: "inside",
              formatter: "{d}%",
            },
            data: this.positionSalaryList,
          },
        ],
      };
      myChart.setOption(option);
    },
    myThreeEcharts() {
      var myChart = this.$echarts.init(document.getElementById("three-echart"));
      //配置图表
      var option = {
        legend: {
          top: "10",
          left: "13%",
          icon: "roundRect",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "20%",
          left: "15%",
          width: "80%",
          height: "70%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.dateList,
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "社保缴纳",
            type: "line",
            stack: "Total",
            smooth: true,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(95, 178, 249)",
                },
                {
                  offset: 1,
                  color: "rgb(176, 220, 249)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#1484FF", //改变折线点的颜色
                lineStyle: {
                  color: "rgb(176, 220, 249)", //改变折线颜色
                },
              },
            },
            data: this.siList,
          },
          {
            name: "公积金缴纳",
            type: "line",
            stack: "Total",
            smooth: true,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#8848E1",
                },
                {
                  offset: 1,
                  color: "#C5C1F4",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#8848E1", //改变折线点的颜色
                lineStyle: {
                  color: "#C5C1F4", //改变折线颜色
                },
              },
            },
            data: this.fundList,
          },
          {
            name: "应发工资",
            type: "line",
            stack: "Total",
            smooth: true,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#29EBB6",
                },
                {
                  offset: 1,
                  color: "#A3F4E0",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "#29EBB6", //改变折线点的颜色
                lineStyle: {
                  color: "#A3F4E0", //改变折线颜色
                },
              },
            },
            data: this.salaryList,
          },
        ],
      };
      myChart.setOption(option);
    },
    myFourEcharts() {
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("four-echart"));
      //配置图表
      var option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#1584FF",
          "#FF5215",
          "#29EBB6",
          "#F6D816",
          "#8848E1",
          "#4855E1",
          "#48E178",
          "#B1E148",
          "#E148B2",
          "#CB48E1",
        ],
        legend: {
          type: "scroll",
          orient: "vertical",
          height: "30%",
          textStyle: {
            rich: {
              name: {
                fontSize: 12,
                color: "#666666",
                width: 80,
                padding: [0, 0, 0, 0],
              },
              num: {
                fontSize: 18,
                fontWeight: 600,
                padding: [0, 0, 0, 0],
                color: "#333333",
              },
              limit: {
                fontSize: 12,
                width: 50,
                padding: [0, 0, 0, 0],
                color: "#666666",
              },
              per: {
                fontSize: 18,
                fontWeight: 600,
                padding: [0, 0, 0, 0],
                color: "#333333",
              },
            },
          },
          formatter: function(name) {
            let tarValue;
            let total = 0;
            if (that.salaryStructureList.length > 0) {
              for (let i = 0; i < that.salaryStructureList.length; i++) {
                total += parseFloat(that.salaryStructureList[i].value);
                if (that.salaryStructureList[i].name == name) {
                  tarValue = parseFloat(that.salaryStructureList[i].value);
                }
              }
              let percent = ((tarValue / total) * 100).toFixed(2);
              return [`{name|${name}}{num|${tarValue}}{limit|万元}{per|占比${percent}%}`];
            }
          },
          icon: "circle",
          bottom: "2%",
          right: "5%",
        },
        series: [
          {
            name: "薪资构成",
            type: "pie",
            radius: ["0%", "55%"],
            center: ["50%", "33%"],
            label: {
              formatter: "{b}\n{c}({d}%)\n",
              show: false,
            },
            data: this.salaryStructureList,
          },
        ],
      };
      myChart.setOption(option);
    },
    onCompanyFinish(value, selectedOptions, tabIndex) {
      // 选择所属公司部门确认
      console.log(value, selectedOptions, tabIndex);
      // this.selectRoomName = value.name;
      //   this.requestData.roomId = value.value;
      //   this.roomShow = false;
      //   this.resdata = []
      //   this.getData()
    },
    backPage() {
      // 回退到app
      window.location.href = "jsToOc://back";
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.3rem 0.3rem;
  border-bottom: 1px solid #f0f2f5;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 菜单条件筛选部分 */
.menu-select {
  display: flex;
  align-items: center;
  background-color: white;
  justify-content: space-around;
  height: 1.3rem;
}
.menu-select > div {
  display: flex;
  width: 45%;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939496;
}
.menu-select > div > span {
  margin-right: 0.1rem;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.menu-select > div:nth-child(1) {
  margin-left: 0.5rem;
}

.menu-select > div:nth-child(2) {
  margin-right: 0.5rem;
}
/* 图表部分 */
.echart-show {
  padding: 0.5rem 0.2rem;
}
.echart-show > div {
  background-color: white;
  border-radius: 0.2rem;
  margin-bottom: 0.5rem;
}
.echart-show > div > div:nth-child(1) {
  text-indent: 0.5rem;
  font-size: 0.4rem;
  font-weight: 700;
  color: #333333;
  padding: 0.3rem 0;
  border-bottom: 1px solid #f3f3f3;
}
.echart-show > div > div:nth-child(1) span {
  text-indent: 0.5rem;
  font-size: 0.2rem;
  color: #999999;
}
.echart-show > div > div:nth-child(2) {
  width: 100%;
  height: 350px;
}

/* 无数据时 */
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}
.no-data img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.5rem;
}
.no-data span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  font-size: 28rpx !important;
}
/* 选择公司弹框 */
.pop-title{
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
}
.pop-title>span:nth-child(1){
  font-size: 0.5rem;
  font-weight: 700;
  margin-left: 0.3rem;
  margin-right: auto;
  color: #323233;
}
.pop-title>span:nth-child(2){
  font-size: 0.4rem;
  margin-right: 0.4rem;
  color: #1484FF;
}
.list-content{
  display: flex;
  flex-direction: column;
  padding: 0.3rem 0.5rem;
  line-height: 0.7rem;
}
.list-content div{
  font-size: 0.35rem;
  font-weight: 400;
  color: #323233;
}
/* 选择时间日期弹框 */
.date-title{
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  border-bottom: 1px solid #E5E5E5;
}
.date-title>span:nth-child(1){
  font-size: 0.4rem;
  margin-left: 0.4rem;
  color: #1484FF;
}
.date-title>span:nth-child(2){
  font-size: 0.5rem;
  margin: auto;
  color: #323233;
}
.date-title>span:nth-child(3){
  font-size: 0.4rem;
  margin-right: 0.4rem;
  color: #1484FF;
}
.type-select{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.6rem;
}
.type-select span{
  cursor: pointer;
  padding: 0.1rem 0.3rem;
  background: #FFFFFF;
  border: 1px solid #1484FF;
}
.type-select span:nth-child(1){
  border-right: 0;
}
.date-selector{
  margin-top: 0.6rem;
  margin-bottom: 0.3rem;
}
.date-selector>.two-div{
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-selector>div /deep/.van-picker__toolbar{
  display: none !important;
}
.date-selector>.two-div /deep/.van-picker{
  width: 49% !important;
}
</style>
